// @flow

import { MHRecordingConstants } from '../base/lib-meet-hour';


/**
 * The identifier of the sound to be played when a live streaming session is stopped.
 *
 * @type {string}
 */
export const LIVE_STREAMING_OFF_SOUND_ID = 'LIVE_STREAMING_OFF_SOUND';

/**
 * The identifier of the sound to be played when a live streaming session is started.
 *
 * @type {string}
 */
export const LIVE_STREAMING_ON_SOUND_ID = 'LIVE_STREAMING_ON_SOUND';

/**
 * The identifier of the sound to be played when a recording session is stopped.
 *
 * @type {string}
 */
export const RECORDING_OFF_SOUND_ID = 'RECORDING_OFF_SOUND';

/**
 * The identifier of the sound to be played when a recording session is started.
 *
 * @type {string}
 */
export const RECORDING_ON_SOUND_ID = 'RECORDING_ON_SOUND';

/**
 * Expected supported recording types.
 *
 * @enum {string}
 */
export const RECORDING_TYPES = {
    JITSI_REC_SERVICE: 'recording-service',
    DROPBOX: 'dropbox'
};

/**
 * An array defining the priorities of the recording (or live streaming)
 * statuses, where the index of the array is the priority itself.
 *
 * @type {Array<string>}
 */
export const RECORDING_STATUS_PRIORITIES = [
    MHRecordingConstants.status.OFF,
    MHRecordingConstants.status.PENDING,
    MHRecordingConstants.status.ON
];


export const LIVESTREAM_TOOLS = [
    {
        enabled: true,
        Facebook: {
            apiLogin: false,
            enabled: true


        },

        icon: 'IconFacebook',
        title: 'Facebook',
        toggle: false


    },
    {
        enabled: true,
        icon: 'IconYoutube',
        title: 'Youtube',
        toggle: false,
        YouTube: {
            apiLogin: false,
            enabled: true
        }
    },
    {
        enabled: true,
        icon: 'IconTwitch',
        title: 'Twitch',
        toggle: false,
        Twitch: {
            apiLogin: false,
            enabled: true

        }
    },
    {
        enabled: true,
        icon: 'IconLinkedin',
        LinkedIn: {
            apiLogin: false,
            enabled: true

        },
        title: 'LinkedIn',
        toggle: false
    },
    {
        enabled: true,
        icon: 'IconInstagram',
        Instagram: {
            apiLogin: false,
            enabled: true
        },
        title: 'Instagram',
        toggle: false


    },
    {
        CustomRtmp: {
            apiLogin: false,
            enabled: true
        },

        enabled: true,
        icon: 'IconCustom',
        title: 'Custom RTMP',
        toggle: false


    },
    {
        CustomRtmps: {
            apiLogin: false,
            enabled: true
        },
        enabled: true,
        icon: 'IconCustom',
        title: 'Custom RTMPS',
        toggle: false


    },
    {
        enabled: true,
        icon: 'IconVimeo',
        title: 'Vimeo',
        toggle: false,
        Vimeo: {
            apiLogin: false,
            enabled: false

        }
    }
];

export const RECORDING_TOOLS = [
    {
        DropBox: {
            apiLogin: false,
            enabled: true


        },
        enabled: true,
        icon: 'IconRec',
        title: 'DropBox Recording',
        toggle: false


    }
];


